function initHeaderChroxelSticky() {
  document.querySelectorAll('[data-sticky-type="always"], [data-sticky-type="on-scroll-up"]').forEach(function (wrapper) {
    if (wrapper.dataset.stickyInitialized === 'true') return;

    var section = wrapper.closest('.section-header-chroxel');
    if (!section) return;

    wrapper.dataset.stickyInitialized = 'true';
    var stickyType = wrapper.dataset.stickyType;
    var previousScrollTop = window.scrollY;
    wrapper.classList.remove('is-visible');
    var stickyStart = wrapper.getBoundingClientRect().top + window.scrollY;

    function setSectionHeight() {
      section.style.minHeight = wrapper.offsetHeight + 'px';
    }

    function updateHeader() {
      if (stickyType === 'always') {
        wrapper.classList.toggle('is-visible', window.scrollY >= stickyStart);
        return;
      }

      var currentScrollTop = window.scrollY;
      var headerHeight = wrapper.offsetHeight;
      var scrollingUp = currentScrollTop < previousScrollTop;
      var shouldShow = scrollingUp && currentScrollTop > headerHeight;

      wrapper.classList.toggle('is-visible', shouldShow);

      if (currentScrollTop <= headerHeight) {
        wrapper.classList.remove('is-visible');
      }

      previousScrollTop = currentScrollTop;
    }

    setSectionHeight();
    updateHeader();
    window.addEventListener('resize', setSectionHeight);
    window.addEventListener('scroll', updateHeader, { passive: true });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeaderChroxelSticky);
} else {
  initHeaderChroxelSticky();
}
